<template>

  <div :class="cardWrapperClasses"
       :style="mtgCardStyle"
       v-bind="nonAriaAttrs">
    <a class="card-link card-border"
       :class="cardHrefClass"
       :data-cktag="cktag"
       :href="href"
       :style="mtgCardBorderStyle"
       :aria-label="$attrs['aria-label'] || ariaLabel"
       @click.prevent="checkCardClick"
       v-if="href.length > 0" >
      <img v-show="!showFlipImage"
          :class="cardImageClass"
          :alt="alt"
          :src="imageSrc"
      />
      <img v-show="showFlipImage"
           :class="cardImageClass + ' flip'"
           :alt="alt"
           :src="flipImageSrc"
      />
      <i class="zoom-icon fa-regular fa-magnifying-glass-plus" @click.prevent="zoomCard" v-if="this.hasZoom && !this.isZoomed"></i>
      <i class="unzoom-icon fa-regular fa-magnifying-glass-minus" v-if="this.isZoomed"  @click.stop.prevent="unZoomCard"></i>
      <div class="oversized" v-if="isOversized">OVERSIZED</div>
    </a>
    <div class="card-border"
         :class="cardHrefClass"
         :style="mtgCardBorderStyle"
         v-if="href.length == 0">
      <img v-show="!showFlipImage"
           :class="cardImageClass"
           :alt="alt"
           :src="imageSrc"
      />
      <img v-show="showFlipImage"
           :class="cardImageClass + ' flip'"
           :alt="alt"
           :src="flipImageSrc"
      />
      <i class="zoom-icon fa-regular fa-magnifying-glass-plus" @click.prevent="zoomCard" v-if="this.hasZoom && !this.isZoomed"></i>
      <i class="unzoom-icon fa-regular fa-magnifying-glass-minus" v-if="this.isZoomed"  @click.stop.prevent="unZoomCard"></i>
    </div>

    <div class="zoom-background" @click="unZoomCard" v-if="isZoomed"></div>

  </div>

</template>

<script>
/* Universal MTG Card Component */
export default {
  name: 'MtgCardImage',
  inheritAttrs: false,
  props: {
    alt: {
      default: 'MTG Card',
      type: String,
    },
    ariaLabel: {
      default: '',
      type: String,
    },
    borderType: {
      default: 'black',
      type: String,
    },
    cktag: {
      default: '',
      type: String,
    },
    hasZoom: {
      default: false,
      type: Boolean,
    },
    href: {
      default: '',
      type: String,
    },
    isFoil: {
      default: false,
      type: Boolean,
    },
    maskColor: {
      default: '',
      type: String,
    },
    maxZoomWidth: {
      default: 400,
      type: Number,
    },
    isOversized: {
      default: false,
      type: Boolean,
    },
    src: {
      default: '',
      type: String,
    },
    srcFlipCard: {
      default: '',
      type: String,
    },
    srcFlipCardImgix: {
      default: '',
      type: String,
    },
    srcImgix: {
      default: '',
      type: String,
    },
    srcLarge: {
      default: '',
      type: String,
    },
    width: {
      default: 100,
      type: Number,
    }

  },
  computed: {
    cardImageClass() {
      return this.hasImgix ? 'imgix-card-image' : 'card-image';
    },
    cardHrefClass() {
      if(this.hasImgix) {
        return '';
      } else {
        let classes = this.isFoil ? 'is-foil' : '';
        if(typeof this.borderType == 'string' && this.borderType.length > 0) {
          classes += ` ${this.borderType}`;
        }
        return classes;
      }
    },
    cardWrapperClasses() {
      let cardWrapperClass = 'mtg-card ';
      if(this.hasImgix) {
        cardWrapperClass += 'imgix';
      } else {
        cardWrapperClass += this.borderType;
      }
      if (this.isOversized) {
        cardWrapperClass +=  ' oversized-card'
      }
      if (this.isZoomed) {
        cardWrapperClass += ' zoomed'
      }
      return cardWrapperClass;
    },
    hasImgix() {
      return this.srcImgix.length > 0;
    },
    imageSrc(){
        return this.hasImgix ? this.imgixUri : this.src;
    },
    flipImageSrc(){
        return this.srcFlipCardImgix.length > 0 ? this.srcFlipCardImgix : this.srcFlipCard;
    },
    imgixUri() {
      if (this.isZoomed) {
        return this.srcImgix + '&auto=format&q=35&fit=clip&usm=15&sharp=30&usmrad=1&width=' + this.maxZoomWidth + '&blend-w=' +  this.maxZoomWidth;
      }
      return this.srcImgix + '&auto=format&q=35&fit=clip&usm=15&sharp=30&usmrad=1&width=' + this.width + '&blend-w=' +  this.width;

    },
    mtgCardStyle() {
      let styleObject =  {
        backgroundColor: this.maskColor,
        height: this.heightPx(),
        width: this.widthPx(),
      };
      if(this.hasImgix) {
        styleObject.height = 'auto';
      }
      if(typeof this.transformDegree == 'number'){
        styleObject.transform = 'rotateY('+ this.transformDegree +'deg)';
      }
      return styleObject;

    },

    mtgCardBorderStyle() {

      this.styles.left = this.zoomPosition.left;
      this.styles.top = this.zoomPosition.top;
      if (this.isZoomed) {
        this.maxZoomWidth = this.maxZoomWidth > window.innerWidth ? window.innerWidth : this.maxZoomWidth;
        this.styles.height = Math.ceil(this.maxZoomWidth / this.BASE_WIDTH) * this.BASE_HEIGHT;

        if (this.styles.height > window.innerHeight) {
          this.styles.height = window.innerHeight;
          this.styles.width = (this.BASE_WIDTH * this.styles.height) / this.BASE_HEIGHT;
        } else {
          this.styles.width = this.maxZoomWidth;
        }

        this.styles.borderWidth = Math.ceil(this.styles.width * this.BASE_BORDER_RATIO) + 'px';
        this.styles.borderRadius = this.borderRadius(this.styles.width, this.styles.borderWidth);
        this.styles.marginTop = '-' + Math.ceil(this.styles.height / 2) + 'px';
        this.styles.marginLeft = '-' + Math.ceil(this.styles.width / 2) + 'px';
        this.styles.height = this.styles.height + 'px';
        this.styles.width = this.styles.width + 'px';

      } else {
        this.styles.borderWidth = Math.ceil(this.width * this.BASE_BORDER_RATIO) + 'px';
        this.styles.borderRadius = this.borderRadius(this.styles.width, this.styles.borderWidth);
        this.styles.height = this.heightPx();
        this.styles.width = this.widthPx();
        this.styles.marginLeft = '0px';
        this.styles.marginTop = '0px';

      }

      return this.styles;
    },
    srcSet() {
      if (this.hasImgix) {
        return this.imgixUri + '&dpr=1 1x,' + this.imgixUri + '&dpr=2 2x,' + this.imgixUri + '&dpr=3 3x,' + this.imgixUri + '&dpr=4 4x';
      }
      return '';
    }
  },
  data() {
    return {
      BASE_ALPHA_BORDER_RADIUS_RATIO: .06,
      BASE_BORDER_RATIO: .038,
      BASE_WIDTH: 4.948,
      BASE_HEIGHT: 6.935,
      borderStyleObject: {},
      initialLeft: null,
      initialTop: null,
      isZoomed: false,
      isZooming: false,
      showFlipImage: false,
      transformDegree: null,
      styles: {},
      zoomPosition: {
        left: null,
        top: null
      }

    };
  },
  methods: {

    flipImage() {

      let rotateInterval = setInterval(() => {
        if(typeof this.transformDegree !== 'number') {
          this.transformDegree = 0;
        }
        this.transformDegree = this.transformDegree-1;
        if(this.transformDegree === -90) {
          this.showFlipImage = !this.showFlipImage;
          this.transformDegree = -270;
        } else if(this.transformDegree === -360) {
          this.transformDegree = null;
          clearInterval(rotateInterval);
        }
      },6);

    },
    height() {
      return Math.ceil(((this.width) / this.BASE_WIDTH) * this.BASE_HEIGHT);
    },
    heightPx() {
      return this.height() + 'px';
    },
    borderRadius(cardWidth, borderWidth) {
      if (this.borderType == 'alpha') {
        return Math.ceil(cardWidth * this.BASE_ALPHA_BORDER_RADIUS_RATIO) + 'px';
      // borderType is inferred through presentation logic in ck-commerce: https://github.com/cardkingdom/ck-commerce/blob/d8de148bba9f80a4c685a1f7552c2a2eb70d2b8c/commerce/app/Catalog/Models/Product.php#L360-L414
      // this specific 'gold' property targets products with "primary_category_id"
      // values which currently align to products within the "Collectors" and
      // "International Collectors" editions.
      } else if (this.borderType == 'gold') {
        return '0px';
      } else {
        return borderWidth;
      }
    },
    checkCardClick() {
      if(this.href.length > 0 && !this.isZoomed) {
        window.location.href = this.href;
      } else if(this.isZoomed && this.isZooming == false) {
        this.isZoomed = false;
      }

    },
    widthPx() {
      return this.width + 'px';
    },
    zoomCard() {
      this.isZoomed = true;
      this.isZooming = true;
      this.$nextTick(() => {
        this.isZooming = false;
        if(!this.hasImgix && this.srcLarge.length > 0) {
          this.imageSrc = this.srcLarge; //swap in hi-res image
        }

      });

    },
    unZoomCard() {
      this.isZoomed = false;
    },


  },
  mounted() {
    if(this.srcFlipCard.length > 0) {
      $(document).on('swapFlipImages.ck', () => {
        if(this.srcFlipCard.length > 0) {
          this.flipImage();
        }
      });
    }
    if(this.srcFlipCardImgix.length > 0) {
      this.srcFlipCardImgix = this.srcFlipCardImgix + '&auto=format&q=35&fit=clip&usm=15&sharp=30&usmrad=1&width=' + this.width + '&blend-w=' +  this.width;
    }
  }

};
</script>

<style lang="scss">

.mtg-card {
  display: inline-block;
  position: relative;
}

.mtg-card .card-image {
  height: 100%;
  width:100%;
}

.mtg-card .card-border {
  background: #1a1a1a url("/local/images/common/mtg_card_back_lo_res.jpg") no-repeat center;
  background-size: cover;
  border: 6px solid #000;
  border-radius: 6px;
  display: inline-block;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.mtg-card.imgix .card-border {
  border: none;
}

.mtg-card.zoomed .card-border {
  position: fixed !important;
  margin-top: 0px;
  z-index: 999999;
  top: 50% !important;
  left: 50% !important;
}

.mtg-card .card-border.border-white,
.cardDetail .suggestions .cardItem.white .card-border,
.mtg-card.white .card-border {
  border-color: #f8f8f8;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.8);
}
.mtg-card .card-border.border-silver,
.cardDetail .suggestions .cardItem.silver .card-border,
.mtg-card.silver .card-border {
  border-color: #777;
}

.mtg-card .card-border.border-noBorder,
.mtg-card.noBorder .card-border,
.mtg-card.noBorder .card-border.zoomed {
  background-color: transparent !important;
  border: none !important;
}

.mtg-card .card-border.is-foil.border-noBorder::after,
.mtg-card .card-border.is-foil.noBorder::after {
  border-radius: 6px;
}

.mtg-card .card-border.border-noBorderCurved,
.mtg-card.noBorderCurved .card-border {
  background-color: transparent;
  background-image: url()
}

.mtg-card.border-noBorderCurved img,
.mtg-card.noBorderCurved img {
  background-clip: padding-box;
  background-color: transparent;
  border-radius: 11px;
}

.mtg-card.zoomed.border-noBorderCurved img,
.mtg-card.zoomed.noBorderCurved img {
  border-radius: 22px;
}

/* foil treatments */
.card-border.is-foil::after {
  content: "";
  color: transparent;
  font-weight: bold;
  display: inline-block;
  height: 100%;
  left: 0px;
  position: absolute;
  opacity: .8;
  top: 0px;
  width: 100%;
  background: rgba(222, 197, 37, 0);
  background: -moz-linear-gradient(-45deg, rgba(222, 197, 37, 0) 0%, rgba(222, 197, 37, 0) 1%, rgba(255, 8, 8, 0.06) 19%, rgba(239, 111, 23, 0.1) 32%, rgba(222, 213, 37, 0.23) 45%, rgba(36, 222, 101, 0.39) 62%, rgba(47, 221, 109, 0.4) 63%, rgba(216, 208, 239, 0.39) 79%, rgba(131, 123, 173, 0.38) 88%, rgba(136, 129, 178, 0.38) 89%, rgba(193, 191, 234, 0) 100%);
  background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(222, 197, 37, 0)), color-stop(1%, rgba(222, 197, 37, 0)), color-stop(19%, rgba(255, 8, 8, 0.06)), color-stop(32%, rgba(239, 111, 23, 0.1)), color-stop(45%, rgba(222, 213, 37, 0.23)), color-stop(62%, rgba(36, 222, 101, 0.39)), color-stop(63%, rgba(47, 221, 109, 0.4)), color-stop(79%, rgba(216, 208, 239, 0.39)), color-stop(88%, rgba(131, 123, 173, 0.38)), color-stop(89%, rgba(136, 129, 178, 0.38)), color-stop(100%, rgba(193, 191, 234, 0)));
  background: -webkit-linear-gradient(-45deg, rgba(222, 197, 37, 0) 0%, rgba(222, 197, 37, 0) 1%, rgba(255, 8, 8, 0.06) 19%, rgba(239, 111, 23, 0.1) 32%, rgba(222, 213, 37, 0.23) 45%, rgba(36, 222, 101, 0.39) 62%, rgba(47, 221, 109, 0.4) 63%, rgba(216, 208, 239, 0.39) 79%, rgba(131, 123, 173, 0.38) 88%, rgba(136, 129, 178, 0.38) 89%, rgba(193, 191, 234, 0) 100%);
  background: -o-linear-gradient(-45deg, rgba(222, 197, 37, 0) 0%, rgba(222, 197, 37, 0) 1%, rgba(255, 8, 8, 0.06) 19%, rgba(239, 111, 23, 0.1) 32%, rgba(222, 213, 37, 0.23) 45%, rgba(36, 222, 101, 0.39) 62%, rgba(47, 221, 109, 0.4) 63%, rgba(216, 208, 239, 0.39) 79%, rgba(131, 123, 173, 0.38) 88%, rgba(136, 129, 178, 0.38) 89%, rgba(193, 191, 234, 0) 100%);
  background: -ms-linear-gradient(-45deg, rgba(222, 197, 37, 0) 0%, rgba(222, 197, 37, 0) 1%, rgba(255, 8, 8, 0.06) 19%, rgba(239, 111, 23, 0.1) 32%, rgba(222, 213, 37, 0.23) 45%, rgba(36, 222, 101, 0.39) 62%, rgba(47, 221, 109, 0.4) 63%, rgba(216, 208, 239, 0.39) 79%, rgba(131, 123, 173, 0.38) 88%, rgba(136, 129, 178, 0.38) 89%, rgba(193, 191, 234, 0) 100%);
  background: linear-gradient(135deg, rgba(222, 197, 37, 0) 0%, rgba(222, 197, 37, 0) 1%, rgba(255, 8, 8, 0.06) 19%, rgba(239, 111, 23, 0.1) 32%, rgba(222, 213, 37, 0.23) 45%, rgba(36, 222, 101, 0.39) 62%, rgba(47, 221, 109, 0.4) 63%, rgba(216, 208, 239, 0.39) 79%, rgba(131, 123, 173, 0.38) 88%, rgba(136, 129, 178, 0.38) 89%, rgba(193, 191, 234, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#dec525', endColorstr='#c1bfea', GradientType=1);

}

.productItemWrapper:nth-child(3n+0) .card-border.is-foil::after {
  background: rgba(87, 181, 82, 0.34);
  background: -moz-linear-gradient(-45deg, rgba(87, 181, 82, 0.34) 0%, rgba(168, 207, 250, 0.31) 35%, rgba(252, 138, 167, 0.29) 51%, rgba(253, 180, 151, 0.28) 63%, rgba(255, 244, 127, 0.36) 81%, rgba(255, 244, 127, 0.44) 100%);
  background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(87, 181, 82, 0.34)), color-stop(35%, rgba(168, 207, 250, 0.31)), color-stop(51%, rgba(252, 138, 167, 0.29)), color-stop(63%, rgba(253, 180, 151, 0.28)), color-stop(81%, rgba(255, 244, 127, 0.36)), color-stop(100%, rgba(255, 244, 127, 0.44)));
  background: -webkit-linear-gradient(-45deg, rgba(87, 181, 82, 0.34) 0%, rgba(168, 207, 250, 0.31) 35%, rgba(252, 138, 167, 0.29) 51%, rgba(253, 180, 151, 0.28) 63%, rgba(255, 244, 127, 0.36) 81%, rgba(255, 244, 127, 0.44) 100%);
  background: -o-linear-gradient(-45deg, rgba(87, 181, 82, 0.34) 0%, rgba(168, 207, 250, 0.31) 35%, rgba(252, 138, 167, 0.29) 51%, rgba(253, 180, 151, 0.28) 63%, rgba(255, 244, 127, 0.36) 81%, rgba(255, 244, 127, 0.44) 100%);
  background: -ms-linear-gradient(-45deg, rgba(87, 181, 82, 0.34) 0%, rgba(168, 207, 250, 0.31) 35%, rgba(252, 138, 167, 0.29) 51%, rgba(253, 180, 151, 0.28) 63%, rgba(255, 244, 127, 0.36) 81%, rgba(255, 244, 127, 0.44) 100%);
  background: linear-gradient(135deg, rgba(87, 181, 82, 0.34) 0%, rgba(168, 207, 250, 0.31) 35%, rgba(252, 138, 167, 0.29) 51%, rgba(253, 180, 151, 0.28) 63%, rgba(255, 244, 127, 0.36) 81%, rgba(255, 244, 127, 0.44) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#57b552', endColorstr='#fff47f', GradientType=1);
}

.zoom-background {
  background-color: white;
  height: 100%;
  left: 0;
  opacity: .7;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}

/* optional icon/actions*/


.mtg-card .zoom-icon {
  box-sizing: border-box;
  color: #fff;
  display: none;
  font-size: 25px;
  height: 35px;
  margin-top: -35px;
  padding: 5px;
  position: absolute;
  right: 0;
  text-shadow: 0px 0px 3px rgba(0,0,0,0.5);
  top: 100%;
  width: 35px;
  z-index: 1;
}


.mtg-card .unzoom-icon {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: #fff;
  font-size: 2rem;
  text-shadow: 0px 0px 3px rgba(0,0,0,0.5);
  z-index: 1;
}


.oversized-card .oversized {
  color: yellow;
  display: block;
  font-size: 20px;
  position: relative;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
  text-align: center;
  top: -70%;
  width: 100%;

}

.oversized-card .card-link:active,
.oversized-card .card-link:focus,
.oversized-card .card-link:hover {
  text-decoration: none;
}

@media only screen and (min-width: 775px) {
  .mtg-card:hover .zoom-icon {
    display: block;
  }
}


</style>